import { putToS3 } from '@components/Files/UploadProvider/helpers/putToS3';
import type { TUploaderAdapter } from '@components/Files/UploadProvider/types/TUploadParams';
import { fetchUploadParams } from './fetchUploadParams';
import type { TGenerateUploadParams } from './types/TGenerateUploadParams';

export const S3SignedUrlUploader = (generateUploadParams: TGenerateUploadParams): TUploaderAdapter => {
  return {
    requestParams: async ({ file, meta }) => {
      if (!(file instanceof File)) {
        throw new Error('Only File supported');
      }
      return fetchUploadParams(meta.name, meta.extra?.jobId, generateUploadParams);
    },
    performUpload: async ({ file, params, onProgress, signal }) => {
      if (!(file instanceof File)) {
        throw new Error('Only File supported');
      }
      return putToS3({ file, params, onProgress, signal });
    },
  };
};
